import { useConfig } from "../contexts/ConfigContext"
import { contentPath, modules } from "../config/const"
import React from "react"
import { 
  BarChartOutlined, 
  BarcodeOutlined, 
  BookOutlined, 
  CalculatorOutlined, 
  ClockCircleOutlined, 
  FileTextOutlined, 
  KeyOutlined, 
  PlusCircleOutlined, 
  SettingOutlined, 
  ShopOutlined, 
  ShoppingCartOutlined, 
  TeamOutlined} from "@ant-design/icons"
import { useHistory } from "react-router-dom"
import { ItemType } from "antd/es/menu/interface"
import { useUser } from "../contexts/UserContext"
import { SideBar as SharedSideBar } from "@ryo/ui"

const saleOptions = [
  {key: modules.RegisterSale,label:"Nueva Venta", icon: <PlusCircleOutlined />},
  {key: modules.PendingSalesList,label:"Ventas pendientes", icon: <ClockCircleOutlined />},
  {key: modules.BillList,label:"Soportes de venta", icon: <FileTextOutlined />},
  {key: modules.CreditNoteList,label:"Notas de Crédito", icon: <FileTextOutlined />},
  {key: modules.DebitNoteList,label:"Notas de Débito", icon: <FileTextOutlined />},
  {key: modules.SalesReports,label:"Informes", icon: <BarChartOutlined />},
]

const catalogOptions = [
  {key: modules.StorageItemList,label:"Productos", icon: <BarcodeOutlined />},
  {key: modules.ContactList,label:"Contactos", icon: <TeamOutlined />}
]

const settingOptions = [
  {key: modules.POSList,label:"Puntos de venta", icon: <ShopOutlined />},
  {key: modules.CashRegisterList,label:"Cajas", icon: <CalculatorOutlined />},
  {key: modules.CashSessionList,label:"Apertura de caja", icon: <KeyOutlined />},
]

function getMenuItems(permissions:any){
  const views = permissions.views || []
  const availableSaleOptions = saleOptions.filter(el => views.join().includes(el.key.toLowerCase()))
  const availableCatalogOptions = catalogOptions.filter(el => views.join().includes(el.key.toLowerCase()))
  const availableSettingOptions = settingOptions.filter(el => views.join().includes(el.key.toLowerCase()))
  
  const menuItems: ItemType[] = []
  if(availableSaleOptions.length){
    menuItems.push({
      key: "sales",
      icon: <ShoppingCartOutlined />,
      label: "Ventas",
      children: availableSaleOptions as any
    })
  }
  if(availableCatalogOptions.length){
    menuItems.push({
      key: "catalogs",
      icon: <BookOutlined />,
      label: "Catalogos",
      children: availableCatalogOptions as any
    })
  }
  if(availableSettingOptions.length){
    menuItems.push({
      key: "settings",
      icon: <SettingOutlined />,
      label: "Configuración",
      children: availableSettingOptions as any
    })
  }
  return menuItems
}

const getParentKey = (key: string,menuItems:ItemType[]) => {
  const parent = menuItems.find(item => 
    item && "children" in item && Array.isArray((item as any).children) &&
    (item as any).children.some((child: any) => child.key === key)
  );
  return parent?.key?.toString() ?? null;
};

function SideBar(){
  const history = useHistory()
  const {config,updateConfig} = useConfig()
  const {user} = useUser()
  
  const menuItems = React.useMemo(() => getMenuItems(user.permissions), [user.permissions])
  const [openKey, setOpenKey] = React.useState<string | null>(getParentKey(config.module, menuItems)); 

  React.useEffect(() => {
    setOpenKey(getParentKey(config.module, menuItems)); 
  }, [config.module, menuItems]);

  const handleOpenChange = (keys: string[]) => {
    setOpenKey(keys.at(-1) ?? null);
  };

  const toggleCollapsed = () => {
    updateConfig({sideCollapsed:!config.sideCollapsed})
  };

  const handleSelected = (key: string) => {
    const moduleSelectedKey = Object.keys(modules).find(k => modules[k as keyof typeof modules] === key)
    const module = modules[moduleSelectedKey as keyof typeof modules]
    updateConfig({module});
    history.push(contentPath[module])
  }

  return(
    <SharedSideBar 
      activeKey={config.module}
      collapsed={config.sideCollapsed}
      isMobile={config.isMobile}
      menuItems={menuItems}
      openKey={openKey} 
      onToggle={toggleCollapsed}
      onSelect={handleSelected}
      onOpenChange={handleOpenChange} 
      title="Ryo Sales"
      logoSrc="/assets/icons/sales-sidebar.png" 
    />
  )
}

export default SideBar